import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationBarComponent } from 'projects/declarabid-private/src/app/shared/components/navigation-bar/navigation-bar.component';
import { NavigationBarMovilComponent } from '../../../../shared/components/navigation-bar-movil/navigation-bar-movil.component';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.scss',
  imports: [RouterOutlet, NavigationBarComponent, NavigationBarMovilComponent],
})
export class AdminComponent {}
